import { get } from 'lodash';

export const recognizedSendersByIdSelector = state => get( state, 'recognizedSenders.byId', {} );
export const recognizedSendersIsLoadingSelector = state => get( state, 'recognizedSenders.isLoading', false );
